/**
 * Shared import dropzone markup + drag/click wiring for transaction and script importers.
 */

function dropzoneMarkup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'rs-import-drop-zone' : _ref$id,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Import file' : _ref$ariaLabel,
    _ref$lead = _ref.lead,
    lead = _ref$lead === void 0 ? 'drag and drop a file here' : _ref$lead,
    _ref$clickHint = _ref.clickHint,
    clickHint = _ref$clickHint === void 0 ? 'or click here' : _ref$clickHint,
    _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? '.saito,.json,application/json,text/plain' : _ref$accept;
  return "\n        <div id=\"".concat(id, "\" class=\"rs-import-dropzone\" tabindex=\"0\" role=\"button\" aria-label=\"").concat(ariaLabel, "\">\n          <svg class=\"rs-import-dropzone-icon\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\">\n            <path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4\"/>\n            <polyline points=\"17 8 12 3 7 8\"/>\n            <line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"15\"/>\n          </svg>\n          <p class=\"rs-import-dropzone-lead\">").concat(lead, "</p>\n          <p class=\"rs-import-dropzone-click\">").concat(clickHint, "</p>\n          <input type=\"file\" class=\"rs-import-file-input\" accept=\"").concat(accept, "\" hidden />\n        </div>");
}
function bindDropzone(root) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    onFile = _ref2.onFile;
  if (!root || typeof onFile !== 'function') {
    return;
  }
  var dropZone = root.querySelector('.rs-import-dropzone');
  var fileInput = root.querySelector('.rs-import-file-input');
  if (!dropZone || !fileInput) {
    return;
  }
  var setDragActive = function setDragActive(active) {
    dropZone.classList.toggle('is-dragover', active);
  };
  var prevent = function prevent(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  dropZone.addEventListener('dragenter', function (e) {
    prevent(e);
    setDragActive(true);
  });
  dropZone.addEventListener('dragover', function (e) {
    prevent(e);
    setDragActive(true);
  });
  dropZone.addEventListener('dragleave', function (e) {
    prevent(e);
    setDragActive(false);
  });
  dropZone.addEventListener('drop', function (e) {
    var _e$dataTransfer;
    prevent(e);
    setDragActive(false);
    var file = (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 || (_e$dataTransfer = _e$dataTransfer.files) === null || _e$dataTransfer === void 0 ? void 0 : _e$dataTransfer[0];
    if (file) {
      onFile(file);
    }
  });
  dropZone.addEventListener('click', function () {
    fileInput.click();
  });
  dropZone.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      fileInput.click();
    }
  });
  fileInput.addEventListener('change', function () {
    var _fileInput$files;
    var file = (_fileInput$files = fileInput.files) === null || _fileInput$files === void 0 ? void 0 : _fileInput$files[0];
    if (file) {
      onFile(file);
    }
    fileInput.value = '';
  });
}
module.exports = {
  dropzoneMarkup: dropzoneMarkup,
  bindDropzone: bindDropzone
};